import type { PickListOption } from '@/common/api/types/picklistOption';
import { OverflowTooltip } from '@/common/components/ui/OverflowTooltip';

export const MultiPickListCell = ({ value }: { value?: PickListOption[] }) =>
  Boolean(value?.length) && (
    <OverflowTooltip>{value?.map((option) => option.name).join(', ')}</OverflowTooltip>
  );
